import React, { type PropsWithChildren } from 'react'

export default function LoginContainer ({ children }: PropsWithChildren): React.ReactElement {
  return (
      <div className='Login flex-grow-1 d-flex align-items-center flex-column'>
        {children}
      </div>
  )
}
